// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9ddfd3a7","455":"91e4a67a","977":"007a2f09"}[chunkId] + ".chunk.js";
};